export default __webpack_public_path__ + "static/char-v-52-zh-Hant-6cf7c05d4474542ebec3fed6c1a5dc06.mp4";